<div class="mainContent">

  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Release Library</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;padding-top:2%">
    
<form [formGroup]="FormValid" novalidate>

  <div class="row">

    <!-- System -->
    <div class="col-lg-6">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>System</mat-label>

        <mat-select formControlName="systemId">

          <mat-option *ngFor="let system of systems"
                      [value]="system.id">
            {{system.systemName}}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="FormValid.get('systemId')?.hasError('required')">
          System is required.
        </mat-error>

      </mat-form-field>
    </div>

    <!-- Release Name -->
    <div class="col-lg-6">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Release Name</mat-label>

        <input
          matInput
          formControlName="releaseName"
          maxlength="200">

        <mat-error *ngIf="FormValid.get('releaseName')?.hasError('required')">
          Release Name is required.
        </mat-error>

      </mat-form-field>
    </div>

  </div>


  <div class="row">

    <!-- Release Version -->
    <div class="col-lg-6">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Release Version</mat-label>

        <input
          matInput
          formControlName="releaseVersion"
          maxlength="100">

        <mat-error *ngIf="FormValid.get('releaseVersion')?.hasError('required')">
          Release Version is required.
        </mat-error>

      </mat-form-field>
    </div>

    <!-- Release Type -->
    <div class="col-lg-6">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Release Type</mat-label>

        <mat-select formControlName="releaseType">

          <mat-option
            *ngFor="let type of releaseTypes"
            [value]="type.lookupvalueid">

            {{type.lookupvalue}}

          </mat-option>

        </mat-select>

        <mat-error *ngIf="FormValid.get('releaseType')?.hasError('required')">
          Release Type is required.
        </mat-error>

      </mat-form-field>
    </div>

  </div>


  <div class="row">

    <!-- Release Classification -->
    <div class="col-lg-6">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Release Classification</mat-label>

        <mat-select formControlName="releaseClassification">

          <mat-option
            *ngFor="let classification of releaseClassifications"
            [value]="classification.lookupvalueid">

            {{classification.lookupvalue}}

          </mat-option>

        </mat-select>

        <mat-error *ngIf="FormValid.get('releaseClassification')?.hasError('required')">
          Release Classification is required.
        </mat-error>

      </mat-form-field>
    </div>

  </div>


  <div class="row">

    <div class="col-lg-12">

      <mat-form-field appearance="outline" style="width:100%">

        <mat-label>Release Description</mat-label>

        <textarea
          matInput
          rows="5"
          maxlength="5000"
          formControlName="releaseDescription">
        </textarea>

        <mat-hint align="end">
          {{FormValid.get('releaseDescription')?.value?.length || 0}} / 5000
        </mat-hint>

      </mat-form-field>

    </div>

  </div>

</form>

  </div>
  <div style="height:5vh">
    <div class="row" style="position:sticky;left:0;bottom:0;width:100%;">

      <div class="col-lg text-center">

        <div style="text-align: end;display:flex; justify-content:flex-end; align-items:center;">
          

          <!-- <form [formGroup]="formValidCheckbox">

                <span *ngIf="buttonName == 'Save'">
                  <mat-checkbox
                    formControlName="isCheckboxSelected"
                    [(ngModel)]="isCheckboxSelected">
                  </mat-checkbox>

                  <span>Create Another</span>
                </span>

          </form> -->

             <!-- <button i18n="@@TargetClear" type="button" (click)="updateData()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button> -->

          <app-common-button
          label={{this.buttonName}}
          title={{this.buttonName}}
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="updateData()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

           <!-- <button i18n="@@TargetCancel" type="button" (click)="close()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button> -->
         
            <app-common-button
          label="Cancel"
          title="Cancel "
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="close()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        </div>
      </div>
    </div>
  </div>
</div>